
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import FinanceUpcomingPayments from '@/components/finance/FinanceUpcomingPayments';

const FinancePaymentsUpcoming = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Upcoming Payments</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Upcoming Payments</CardTitle>
          </CardHeader>
          <CardContent>
            <FinanceUpcomingPayments />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinancePaymentsUpcoming;
